// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  fonts,
  palette: { blue, greyscale, noodle },
} = getTheme();
const RequestModalWrapper: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem;

  .request-modal {
    &__body {
      color: ${greyscale.mineShaft};
      font-size: 1.6rem;
      line-height: 2.4rem;
      text-align: center;
    }

    &__close-icon {
      color: ${blue.riverBed};
      cursor: pointer;
      display: flex;
      font-size: 2rem;
      justify-content: flex-end;
    }

    &__header {
      color: ${greyscale.mineShaft};
      font-family: ${fonts.header};
      font-size: 2.4rem;
      line-height: 3rem;
      margin-bottom: 0.8rem;
      text-align: center;
    }

    &__submit {
      align-items: center;
      align-self: center;
      color: ${greyscale.white};
      cursor: pointer;
      background-color: ${noodle.primary};
      border-radius: 0.4rem;
      display: flex;
      font-size: 1.6rem;
      height: 4.8rem;
      justify-content: center;
      line-height: 1.9rem;
      margin-bottom: 1.6rem;
      transition: all 0.3s;
      width: 22.4rem;

      &:hover {
        background-color: ${noodle.secondary};
      }

      &.disabled {
        cursor: not-allowed;
        color: ${greyscale.smoke};
        background-color: ${greyscale.cloud};
        opacity: 1;

        :focus {
          outline: none;
        }
      }
    }

    &__text {
      color: ${greyscale.mineShaft};
      font-size: 1.6rem;
      line-height: 2.4rem;
      margin-bottom: 1.6rem;
    }
  }

  .disclaimer-checkbox {
    display: flex;

    &__text {
      color: ${greyscale.outerSpace};
      font-size: 1.6rem;
      line-height: 2.4rem;
    }
  }

  .check-container {
    margin-bottom: 1.6rem;
    padding-left: 2.4rem;

    span {
      top: 1.2rem;
    }
  }
`;
export default RequestModalWrapper;
